import { Component, DestroyRef, inject, signal } from "@angular/core";
import { AuthService } from "@kno2/core/auth";
import { WINDOW_TOKEN } from "@kno2/core/browser";
import { SessionService } from "@kno2/core/session";
import { DialogService } from "@kno2/shared/dialog";
import { differenceInSeconds } from "date-fns";

@Component({
    selector: "kno2-session-timeout",
    templateUrl: "./session-timeout.component.html"
})
export class SessionTimeoutComponent {
    private readonly window = inject(WINDOW_TOKEN);
    private readonly destroyRef = inject(DestroyRef);
    private readonly dialogService = inject(DialogService);
    private readonly sessionService = inject(SessionService);
    private readonly authService = inject(AuthService);
    private readonly timeoutSeconds = 60;

    private readonly interval: ReturnType<typeof setInterval>;

    protected readonly timeRemaining = signal(this.timeoutSeconds);

    public constructor() {
        const startTime = Date.now();

        this.interval = setInterval(() => {
            const elapsedSeconds = differenceInSeconds(Date.now(), startTime);
            this.timeRemaining.set(Math.max(0, this.timeoutSeconds - elapsedSeconds));
            if (this.timeRemaining() > 0) return;

            clearInterval(this.interval);
            if (this.window.location.host.includes(".local")) return;

            this.sessionService.sessionExpired.set(true);
            this.authService.logout();
            this.dialogService.close();
        }, 1000);

        this.destroyRef.onDestroy(() => clearInterval(this.interval));
    }

    public close(): void {
        clearInterval(this.interval);
        this.dialogService.close();
    }
}
